// React
import React, { useState, useEffect, useContext } from "react";
// React
// CSS
import styles from "./Files.module.css";
// CSS
// Services
import { getRequestedFilesService } from "../../../Services/Profile/get/getRequestedFilesService";
// Services
// Contexts
import { UserTokenContext } from "../../../Contexts/userToken";
// Contexts
// Models
import { I_File } from "../../../Models/interfaces";
import SingleFile from "./SingleFile/SingleFile";
import { dialog_shop_header } from "../../../Images/images";
import { removePdfRequestsService } from "../../../Services/Profile/post/removePdfRequestsService";
import Swal from "sweetalert2";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { useNavigate } from "react-router-dom";
import { BiArrowBack } from "react-icons/bi";
// Models

type FileProps = {
  setIsNeedFullScreen: React.Dispatch<React.SetStateAction<boolean>>;
};

const Files: React.FunctionComponent<FileProps> = ({ setIsNeedFullScreen }) => {
  const [files, setFiles] = useState<I_File[]>([]);
  const [needToRefresh, setNeedToRefresh] = useState<boolean>(false);
  const userToken = useContext(UserTokenContext);
  const [isPending, setIsPending] = useState<boolean>(true);
  const navigate = useNavigate();
  useEffect(() => {
    const handler = () => {
      navigate("/profile");
    };
    setIsNeedFullScreen(true);
    window.addEventListener("popstate", handler);
    return () => {
      setIsNeedFullScreen(false);
      window.removeEventListener("popstate", handler);
    };
  }, [setIsNeedFullScreen, navigate]);

  useEffect(() => {
    getRequestedFilesService(userToken).then(({ data }) => {
      setFiles(data);
      setIsPending(false);
      const timeOut = setTimeout(() => {
        setNeedToRefresh((prevState) => !prevState);
        console.log("requestSent !");
      }, 10000);

      return () => {
        clearTimeout(timeOut);
      };
    });
  }, [userToken, needToRefresh]);

  return (
    <div
      className={`${styles.filesContainer} flex flex-col items-center w-full relative`}
    >
      <div
        className={`${styles.topItems} flex flex-row-reverse items-center justify-between w-full p-2 relative`}
      >
        <BiArrowBack
          className="absolute top-1/4 left-3 text-2xl"
          onClick={() => {
            navigate(-1);
          }}
        />
        <img src={dialog_shop_header} alt="" className="w-5/12" />
        <div className={`${styles.content} flex flex-col items-end w-7/12`}>
          <h1 className="text-xl">فایل های من</h1>
          <p
            className="w-full text-right text-xs"
            style={{
              width: "calc(100% - 2rem)",
            }}
          >
            دوست من ، ساخت سوال و پاسخنامه حداکثر 5 دقیقه به طول می انجامد .
            همچنین فایل سوال و پاسخنامه شما پس از ساخت در مسیر{" "}
            {"( پروفایل کاربری قسمت <<فایلها>> دخیره میشود)"}
          </p>
        </div>
      </div>
      {isPending ? (
        <>
          <SkeletonTheme
            baseColor="rgba(126, 58, 229 , 0.1)"
            highlightColor="rgba(126, 0, 229, 0.6)"
          >
            <p>
              <Skeleton
                count={5}
                width={"calc(100vw - 2rem)"}
                height={"70px"}
                style={{ marginTop: "1rem" }}
              />
            </p>
          </SkeletonTheme>
        </>
      ) : (
        <div className={`${styles.files} w-full h-full`}>
          {files.map((item) => (
            <SingleFile data={item} key={item.id} />
          ))}
        </div>
      )}

      <button
        className={`${styles.removeBtn} py-2  fixed bottom-2 rounded-lg ${
          window.innerWidth > 600 ? "!left-auto" : "left-0"
        } bg-red-500 text-white `}
        style={{
          bottom: "6vh",
        }}
        onClick={() => {
          Swal.fire({
            icon: "question",
            title: "آیا همه ی موارد حذف شود ؟",
          }).then(({ isConfirmed }) => {
            if (isConfirmed) {
              removePdfRequestsService(userToken)
                .then(({ data: { success } }) => {
                  Swal.fire({ icon: "success", title: success });
                })
                .catch((err) => {
                  console.log(err);
                  Swal.fire({
                    icon: "error",
                    title: err?.response?.data?.message
                      ? err?.response?.data?.message
                      : err.message,
                  });
                });
              return;
            }
          });
        }}
      >
        حذف همه فایل ها
      </button>
    </div>
  );
};

export default Files;
